import { ExclamationCircleOutlined, WarningOutlined } from '@ant-design/icons';
import { t } from '@hefe/i18n';
import {
  BasketballOperationsCenterGame,
  BasketballOperationsCenterOpenTask,
} from '@hefe/models';
import { colors } from '@hefe/ui';
import { formatDateTime } from '@hefe/utils';
import { List, Space, Typography } from 'antd';
import { useMemo } from 'react';

interface OpenTaskItemComponentProps {
  item: BasketballOperationsCenterOpenTask;
  games: { [key: number]: BasketballOperationsCenterGame };
}

export default function OpenTaskItemComponent(
  props: OpenTaskItemComponentProps
) {
  const { item, games } = props;

  const game = useMemo(() => {
    return games[item.game_id];
  }, [games, item.game_id]);

  const task = useMemo(() => {
    return game?.tasks.find((t) => t.id === item.task_id);
  }, [game, item.task_id]);

  const messages = useMemo(() => {
    const messages = [];

    if (!item?.has_teams_assigned) {
      messages.push(
        <Space key="no-team-assigned" style={{ color: colors.orange }}>
          <WarningOutlined />
          {t('operations_center.open_task.messages.no_team_assigned', {
            task: task?.name,
          })}
        </Space>
      );
    }

    if ((item?.missing_number_of_users ?? 0) > 0) {
      messages.push(
        <Space key="not-fully-assigned" style={{ color: colors.red }}>
          <ExclamationCircleOutlined />
          {t('operations_center.open_task.messages.not_fully_assigned', {
            number: item.missing_number_of_users,
            task: task?.name,
          })}
        </Space>
      );
    }

    return messages;
  }, [item.has_teams_assigned, item.is_fully_assigned, task?.name]);

  return (
    <List.Item>
      <List.Item.Meta
        title={<Space direction="vertical">{messages}</Space>}
        description={
          <Typography.Text type="secondary">
            {task?.name || ''} | {game?.home + ' - ' + game?.guest}
          </Typography.Text>
        }
      />
      <Typography.Text type="secondary">
        {formatDateTime(item.date, { withWeekday: 'short' })}
      </Typography.Text>
    </List.Item>
  );
}
